export default __webpack_public_path__ + "static/media/twitter_osadz.88dddab6.webp";